import { Pipe, PipeTransform } from "@angular/core";
import { TranslationService } from "src/service/translation.service";

/**
 * Handle generic translation from any keyword
 */
@Pipe({
    name: "bigtranslation",
    standalone: false
})
export class BigTranslationPipe implements PipeTransform {
  constructor(public _translationService: TranslationService) {}

  transform(stringToTranslate: string): unknown {
    return this._translationService.TranslateText(stringToTranslate);
  }
}
